import { Combobox } from "@msuite/ui/form";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { GetServiceSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";
import { client } from "@/hono";
import { AddServiceModal } from "@/modals/organizations/add-service-modal";

export function AddServiceToContactForm() {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<GetServiceSchema>();
	const addServiceModal = useDisclosure();
	const { data, refetch } = useQuery({
		queryKey: ["services"],
		queryFn: async () => {
			const response = await client.organizations.services.$get();
			const data = await responseHandler(response);
			return data.services;
		},
	});

	/** Render */
	return (
		<React.Fragment>
			<Combobox
				control={methods.control}
				name="serviceId"
				displayValue={(item) => item?.item.service.shortText || ""}
				keyExtractor={(item) => item?.value || ""}
				placeholder={t("placeholders.select_service")}
				isNullable={false}
				isRequired={false}
				label={t("organization.data.service")}
				data-cy="service-parent-service-combobox"
				options={
					data?.map((service) => ({
						label: service.shortText,
						value: service.id,
						item: { service },
					})) || []
				}
				buttons={[
					{
						tags: [t("organization.data.add_service")],
						render: () => (
							<div className="h-stack">
								<Icon name="Plus" />
								<p>{t("organization.data.add_service")}</p>
							</div>
						),
						onClick: () => {
							addServiceModal.onOpen();
						},
					},
				]}
			/>
			<AddServiceModal
				isOpen={addServiceModal.isOpen}
				onClose={addServiceModal.onClose}
				onComplete={async () => {
					await refetch();
				}}
			/>
		</React.Fragment>
	);
}
